const messages = {
  title: "Mārketinga piekrišanas",
  required: "Obligāti",
  answered: "✓ Atbildēts",
  read: "Izlasīts",
  notRead: "Nav izlasīts",
  alreadyAnswered: "Jau atbildēts",
  requiredQuestionsMustBeAccepted:
    "Vēl jāpieņem {count} obligātie jautājumi",
  pleaseAnswerQuestions: "Lūdzu, atbildiet uz šādiem jautājumiem:",
  iAccept: "Es piekrītu",
  scrollToUnlock: "Lai atbloķētu, ritiniet līdz beigām",
  fieldRequired: "Šis lauks ir obligāts",
  scrollToContinue: "↓ Lai turpinātu, ritiniet līdz beigām",
  saving: "Saglabā...",
  saveConsents: "Saglabāt piekrišanas",
  allRequiredAccepted: "✓ Visi obligātie jautājumi pieņemti",
  requiredConsentsCompleted:
    "{completed}/{total} obligātās piekrišanas aizpildītas",
  selectConsentToView:
    "Izvēlieties piekrišanu no saraksta, lai skatītu saturu",
  readAllContentFirst: "Vispirms izlasiet visu saturu: {names}",
  acceptAllRequiredIn:
    "Pieņemiet visus obligātos jautājumus: {names}",
  acceptAllBeforeSaving:
    "Pirms saglabāšanas pieņemiet visus obligātos jautājumus.",
  failedToSave: "Neizdevās saglabāt piekrišanas. Mēģiniet vēlreiz.",
  errorSaving:
    "Saglabājot piekrišanas, radās kļūda. Mēģiniet vēlreiz.",
  failedToLoad: "Neizdevās ielādēt piekrišanas. Atsvaidziniet lapu.",
  viewPdf: "Skatīt PDF",
  requiredConsentTitle: "Obligāta piekrišana",
  acceptAndContinue: "Pieņemt un turpināt",
};

export default {
  messages,
};
